// Fires a deduplicated browser/server PageView on every SPA route change.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendMetaEvent } from "../../hooks/useMetaTracking";

export default function MetaPageViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    sendMetaEvent("PageView", {});
  }, [pathname]);

  return null;
}
